import { createSlice } from '@reduxjs/toolkit';

import { PortalModalDialogSliceState } from './store.types';

const initialPortalModalDialogSliceState: PortalModalDialogSliceState = {
  currentModal: null,
  modalActions: undefined,
  customDescriptionContent: undefined
};

const portalModalDialogSlice = createSlice({
  name: 'portalModalDialogs',
  initialState: initialPortalModalDialogSliceState,
  reducers: {
    openModal: (state, action) => {
      state.currentModal = action.payload.currentModal;
      state.modalActions = action.payload.modalActions;
      state.customDescriptionContent = action.payload.customDescriptionContent;
    },
    closeModal: (state) => {
      state.currentModal = null;
      state.modalActions = undefined;
      state.customDescriptionContent = undefined;
    }
  }
});

export const { openModal, closeModal } = portalModalDialogSlice.actions;

export default portalModalDialogSlice.reducer;
